<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="550" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Duplicate campaign
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      div.text-md.font-semibold.neutral700--text Select which element you want to include in your duplicate:
      y-checkbox.mb-n2.mt-2(v-model="duplicate.name")
        template(#label)
          .text-md.font-medium.neutral700--text Name
      y-checkbox.mb-n2.mt-2(v-model="duplicate.settings")
        template(#label)
          .text-md.font-medium.neutral700--text Settings (Reward, usage limit, active time, how to redeem)
      y-checkbox.mb-n2.mt-2(v-model="duplicate.applied_products")
        template(#label)
          .text-md.font-medium.neutral700--text Applied inventory and services
      y-checkbox.mb-n2.mt-2(v-model="duplicate.audiences")
        template(#label)
          .text-md.font-medium.neutral700--text Audience
      y-checkbox.mb-n2.mt-2(v-model="duplicate.thankyou_msg")
        template(#label)
          .text-md.font-medium.neutral700--text Thank you message settings
      y-checkbox.mb-n2.mt-2(v-model="duplicate.sms_content")
        template(#label)
          .text-md.font-medium.neutral700--text SMS content and settings
      y-checkbox.mb-n2.mt-2(v-model="duplicate.email_content")
        template(#label)
          .text-md.font-medium.neutral700--text Email content and settings
      y-checkbox.mb-n2.mt-2(v-model="duplicate.whatsapp_content")
        template(#label)
          .text-md.font-medium.neutral700--text WhatsApp content

    v-divider
    v-card-actions.py-4.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Duplicate" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isLoading: false,
      duplicate: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isLoading = true
      this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/duplicate`, { ...this.duplicate })
        .then(() => {
          this.$emit('updated')
          this.showMessage(['success', 'Campaign duplicated successfully'])
          this.closeDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>